import { CRUDAction } from 'common/constants/permission'
import { useFeatureEnabled } from 'core/feature-config/api/queries'
import { useGetCRUDByFeature } from 'modules/user/api/selector'
import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { PATH_DASHBOARD } from 'routes/paths'

import LoadingScreen from 'components/LoadingScreen'

interface FeatureGuardProps {
  featureKey: string
  permissionKey?: string
  children: ReactNode
}

export default function FeatureGuard({ featureKey, permissionKey, children }: FeatureGuardProps) {
  const { data: featureEnabled, isLoading } = useFeatureEnabled(featureKey)
  const crud = useGetCRUDByFeature(permissionKey ?? '')

  const permissionAllowed = !permissionKey || crud?.[CRUDAction.Read] === 1

  if (isLoading) return <LoadingScreen />
  if (!featureEnabled || !permissionAllowed) return <Navigate to={PATH_DASHBOARD.farms.root} replace />
  return <>{children}</>
}
